import script from "./TradePassportClientsBusiness.vue?vue&type=script&setup=true&lang=js"
export * from "./TradePassportClientsBusiness.vue?vue&type=script&setup=true&lang=js"

import "./TradePassportClientsBusiness.vue?vue&type=style&index=0&id=332b7868&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-332b7868"]])

export default __exports__